"use client";
import InViewAnimation from "@/components/utils/InViewAnimation";

const profiles = [
  {
    name: "富松 俊彦",
    position: "代表取締役<br />Co-Founder",
    text: "BGの代表として、農家や企業、自治体などとの連携を推進。農業のもつ教育的な側面を価値化し、保育園の子どもたちに食育を目的とした給食食材のお届けサービスを展開する（株）ベジリンクの創業者として、 さまざまな農家とのつながりのなかで、土壌に秘められた可能性に心を奪われ、農業の持続可能性を高めるためにBGを創業。",
  },
  {
    name: "久保田 龍星",
    position: "取締役<br />Chief Operating Officer",
    text: "最高執行責任者として、経営戦略と執行を統括。住友商事（株）にて投資・事業開発、経営戦略策等を経て、独立後に農業による地方創生や生産者の経営支援を行う中で、創造力溢れる農家との出会いがきっかけで、農業に対する社会のイメージを変え、農家が自身の想いを実現できる社会にしたいと思い、BGに参画。",
  },
  {
    name: "瓜 哲史",
    position: "取締役<br />Hokkaido Branch",
    text: "北海道の責任者として生産者に伴走しながら、Next Green Methodの普及やオールインワン有機発酵資材「Soil Next」のサプライチェーンマネジメントを担当。住友商事（株）にて海外ヘルスケア事業の立ち上げなどを経て、自給自足をする兄がきっかけで農業に興味を持ち、全国の農家に足を運び、その生き様に惚れる。農業の可能性と農家の尊さを社会に伝えたいと思い、BGに参画。",
  },
  {
    name: "林 譲",
    position: "顧問<br />Co-Founder",
    text: "「豊かな記憶となる景色を創り出す」をビジョンに掲げ、1990 年に設立した（株）エグゼクインターナショナルにおいて、「中身を掘り下げ、価値を見出し、具体的なイメージを創り出す」コンテンツメイカーとして従事してきたこれまでの知見・経験を生かし、BGにおいてはファウンダーとして、これからの生活様式の豊かさの本質を見極め、これまでにない視点で農業文化の価値向上と国際社会にまでも普及させることを目的としたブランディングに専心する。",
  },
]

const companyList = [
  {
    title: "社名",
    text: "株式会社BG",
  },
  {
    title: "設立年月日",
    text: "令和5年2月15日（令和3年4月創業）",
  },
  {
    title: "代表取締役",
    text: "富松 俊彦",
  },
  {
    title: "所在地",
    text: "本社 : <br />〒153-0051<br />東京都目黒区上目黒5-18-11<br /><br />北海道支店 : <br />〒080-0802<br />北海道帯広市東2条南13-19<br /><br />北海道資材製造拠点 : <br /><ol><li>北海道深川市一已町字一已2405-23</li><li>北海道中川郡本別町美蘭別486-1</li></ol>",
  },
  {
    title: "資本金",
    text: "300万円",
  },
  {
    title: "事業",
    text: "<ol><li>農業の研究開発、ソリューション販売およびコンサルティング業務</li><li>カーボンクレジットの開発・売買、及びカーボンオフセットに関するコンサルティング</li><li>農産物のブランディング、生産、加工及び販売</li></ol>",
  },
  {
    title: "取得認証",
    text: "ISO14064-2<br />（プロジェクトレベルでの排出削減・吸収量の算定・報告に関する国際規格）",
  },
]
export default function PageComponent({}) {
  return (
    <main className="page page-about">
      <div className="container-m">
        <InViewAnimation>
          <div className="page-title-holder">
            <h1 className="h1-title">
              <span className="shoulder">わたしたちについて</span>
              <span className="title en">About Us</span>
            </h1>
            <div className="text-lead bold">
              今までにない視点で<br className="spOnly" />農業のまだ見ぬ価値を発見し<br />
              社会に共有し続ける。
            </div>
          </div>

          <section className="section section-1">
            <div className="section-title-holder">
              <div className="section-lead bold grid-2-col">
                <p>株式会社BGは、「BLACK TO GREEN｜今までにない視点で農業のまだ見ぬ価値を発見し、社会に共有し続ける」ことをミッションに掲げる次世代の農業ベンチャーです。「土」を起点に、「つくり手」と「食べ手」をこれまでのような分断された存在ではなく、共にサステナブルな未来をつくる共同体としてつなぐ、そんな新たな時代のフードシステムを生み出すために、2021年に創業しました。</p>
                <p>農業とは、人と自然の共生によってはじめて成り立つものです。だからこそ、自然に学び、先人たちが築いてきた知恵への敬意を土台にしながら、既成概念にとらわれないアイデアでつくり手と食べ手をつないでいきます。そして、農業が持つさまざまな価値・・・例えば文化的、経済的、環境的な価値を、広く世の中のみなさんと共有しながら、未来へ向けて農業全体をアップデートすることを目指します。</p>
              </div>
            </div>
          </section>

          <section className="section section-gallery">
            <div className="pic-block">
              <div className="pic round">
                <img src="/assets/img/about/gallery/pic-1.jpg" alt="" loading="lazy" />
              </div>
            </div>
          </section>
        </InViewAnimation>
      
        <section className="section section-2">
          <div className="block grid-2-col">
            {profiles.map((prifile,i) => 
              <div className="profile" key={i}>
                <div className="pic">
                  <img src={`/assets/img/about/pic-${i+1}.jpg`} alt="" />
                </div>
                <div className="name bold">{prifile.name}</div>
                <div className="title" dangerouslySetInnerHTML={{__html:prifile.position}}></div>
                <div className="description" dangerouslySetInnerHTML={{__html:prifile.text}}></div>
              </div>
            )}
          </div>

        </section>

        <div className="separator-asterisk en">*</div>

        <section className="section section-3">
          <div className="section-title-holder">
            <h2 className="section-title bold">会社概要</h2>
          </div>
          <ul className="underline-list">
            {companyList.map((company,i) => 
              <li className="underline-list-item" key={i}>
                <div className="title">{company.title}</div>
                <div className="text" dangerouslySetInnerHTML={{__html:company.text}}></div>
              </li>
            )}
          </ul>
        </section>
      </div>
    </main>
  );
}